import { render } from "./bar.vue?vue&type=template&id=9d02762e&ts=true"
import script from "./bar.vue?vue&type=script&setup=true&lang=ts"
export * from "./bar.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/charts/bar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9d02762e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9d02762e', __exports__)) {
    console.log('reload')
    api.reload('9d02762e', __exports__)
  }
  
  module.hot.accept("./bar.vue?vue&type=template&id=9d02762e&ts=true", () => {
    console.log('re-render')
    api.rerender('9d02762e', render)
  })

}


export default __exports__